import { Input } from '@builder.io/sdk';

import sectionFields from 'molecules/Section/config';
import { videoCustomFields } from 'molecules/VideoCustom/config';

const tabFields = [
  {
    name: 'label',
    type: 'string',
    required: true,
    helperText: 'Label for the tab button (shown in the tab selector).',
  },
  {
    name: 'eyebrow',
    type: 'string',
    helperText: 'Optional eyebrow text displayed above the tab heading.',
  },
  {
    name: 'title',
    type: 'string',
    required: true,
    helperText: 'Main heading text for the tab content.',
  },
  {
    name: 'description',
    type: 'richText',
    helperText: 'Body copy or description for the tab content.',
  },
  {
    name: 'as',
    type: 'string',
    enum: [
      { label: 'H1', value: 'h1' },
      { label: 'H2', value: 'h2' },
      { label: 'H3', value: 'h3' },
      { label: 'H4', value: 'h4' },
      { label: 'H5', value: 'h5' },
      { label: 'H6', value: 'h6' },
    ],
    helperText: 'Controls the semantic heading level (H1-H6) for SEO and accessibility.',
  },
  ...videoCustomFields,
] as const;

const buttonSelectorFields = [
  {
    name: 'reverseLayout',
    type: 'boolean',
    defaultValue: false,
    helperText: 'If enabled, places the text on the left and the video on the right.',
  },
  {
    name: 'tabs',
    type: 'list',
    subFields: tabFields,
    required: true,
    defaultValue: [
      { label: '1', title: 'Tab 1' },
      { label: '2', title: 'Tab 2' },
      { label: '3', title: 'Tab 3' },
    ],
    helperText: 'Define one or more tabs. Each tab includes label, title, description, and optional video.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      const tabs = options.get('tabs') || [];
      if (tabs.length < 1) {
        alert('At least one tab is required.');
        options.set('tabs', [{ label: '1', title: 'Tab 1' }]);
      }
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const buttonSelectorConfig = {
  name: 'ButtonSelector',
  inputs: buttonSelectorFields,
};

export type ButtonSelectorProps = GenerateBuilder<typeof buttonSelectorFields>;

export default buttonSelectorConfig;
